import { createApp } from 'vue'
import App from '@/App.vue'

//Vue Router
import router from '@/router'

//Vue Cookies
import cookies from 'vue-cookies';

//Vuetify
import 'vuetify/styles';
import { createVuetify } from 'vuetify'
import colors from 'vuetify/util/colors'
import '@mdi/font/css/materialdesignicons.css'

//Auth0
import { createAuth0 } from '@auth0/auth0-vue';

const vuetify = createVuetify({
    theme: {
        defaultTheme: 'default',
        themes: {
            default: {
                dark: true,
                colors: {
                    background: colors.shades.black,
                    primary: '#8F00C7',
                    secondary: '#EA6619',
                    accent: '#17255A',
                }
            }
        },
    }
});

const auth0 = createAuth0({
    domain: process.env.VUE_APP_AUTH0_DOMAIN,
    clientId: process.env.VUE_APP_AUTH0_CLIENT_ID,
    authorizationParams: {
        audience: process.env.VUE_APP_AUTH0_AUDIENCE,
        redirect_uri: process.env.VUE_APP_AUTH0_REDIRECT_URI,
    },
});

createApp(App)
    .use(router)
    .use(cookies)
    .use(auth0)
    .use(vuetify)
    .mount('#app');
